export interface BrandItem {
  name: string;
  slug: string;
  icon: string;
  seq: string;
  imageQuery: string;
}

export interface ArticleItem {
  title: string;
  slug: string;
  excerpt: string;
  category: string;
  seq: string;
  imageQuery: string;
  imageUrl: string;
}

export interface ArticleSEO {
  slug: string;
  title: string;
  description: string;
  keywords: string;
  category: string;
  categoryLabel: string;
  readingTime: string;
  datePublished: string;
}

export const articleSEOData: Record<string, ArticleSEO> = {
  'czym-jest-kakobuy-spreadsheet': {
    slug: 'czym-jest-kakobuy-spreadsheet',
    title: 'Czym jest Kakobuy Spreadsheet - Kompletny Przewodnik po Arkuszach Produktowych 2026',
    description: 'Dowiedz się czym dokładnie jest Kakobuy Spreadsheet, jak działa system arkuszy produktowych i dlaczego stał się niezbędnym narzędziem dla każdego użytkownika platformy Kakobuy w Polsce.',
    keywords: 'kakobuy spreadsheet, czym jest kakobuy spreadsheet, arkusz kakobuy, kakobuy przewodnik, kakobuy links',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '12 min czytania',
    datePublished: '2026-06-21',
  },
  'jak-dziala-kakobuy': {
    slug: 'jak-dziala-kakobuy',
    title: 'Jak działa Kakobuy - Poradnik dla Początkujących Użytkowników 2026',
    description: 'Poznaj podstawy działania platformy Kakobuy. Przewodnik krok po kroku dla osób rozpoczynających przygodę z zakupami przez agenta zakupowego w Polsce.',
    keywords: 'jak działa kakobuy, kakobuy poradnik, kakobuy dla początkujących, kakobuy instrukcja, kakobuy polska',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '10 min czytania',
    datePublished: '2026-06-20',
  },
  'kakobuy-vs-pandabuy': {
    slug: 'kakobuy-vs-pandabuy',
    title: 'Kakobuy vs Pandabuy - Porównanie Agentów Zakupowych 2026',
    description: 'Szczegółowe porównanie dwóch najpopularniejszych agentów zakupowych: Kakobuy i Pandabuy. Który jest lepszy dla polskich użytkowników w 2026 roku? Analiza cen, wysyłki i obsługi.',
    keywords: 'kakobuy vs pandabuy, porównanie agentów zakupowych, kakobuy pandabuy opinie, najlepszy agent zakupowy',
    category: 'porownania',
    categoryLabel: 'Porównania',
    readingTime: '14 min czytania',
    datePublished: '2026-06-19',
  },
  'czy-kakobuy-jest-bezpieczny': {
    slug: 'czy-kakobuy-jest-bezpieczny',
    title: 'Czy Kakobuy Jest Bezpieczny - Kompletny Poradnik Bezpieczeństwa 2026',
    description: 'Wszystko co musisz wiedzieć o bezpieczeństwie na platformie Kakobuy. Jak chronić swoje dane, unikać oszustw i bezpiecznie dokonywać zakupów przez agenta.',
    keywords: 'czy kakobuy jest bezpieczny, kakobuy bezpieczeństwo, kakobuy oszustwa, bezpieczne zakupy kakobuy, kakobuy opinie',
    category: 'bezpieczenstwo',
    categoryLabel: 'Bezpieczeństwo',
    readingTime: '11 min czytania',
    datePublished: '2026-06-18',
  },
  'najlepsi-sprzedawcy-kakobuy': {
    slug: 'najlepsi-sprzedawcy-kakobuy',
    title: 'Najlepsi Sprzedawcy na Kakobuy - Jak Znaleźć Zaufanych Sprzedawców 2026',
    description: 'Praktyczne wskazówki jak znaleźć sprawdzonych i godnych zaufania sprzedawców na platformie Kakobuy. Kryteria oceny, lista polecanych i na co uważać.',
    keywords: 'najlepsi sprzedawcy kakobuy, kakobuy sellers, zaufani sprzedawcy kakobuy, kakobuy linki, kakobuy spreadsheet',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '13 min czytania',
    datePublished: '2026-06-17',
  },
  'kakobuy-links-2026': {
    slug: 'kakobuy-links-2026',
    title: 'Kakobuy Links 2026 - Aktualna Lista Linków i Arkuszy Produktowych',
    description: 'Zaktualizowana lista wszystkich działających linków do arkuszy produktowych Kakobuy na rok 2026. Regularnie sprawdzane i weryfikowane linki do najlepszych produktów.',
    keywords: 'kakobuy links 2026, kakobuy linki, kakobuy spreadsheet 2026, arkusz kakobuy, kakobuy produkty',
    category: 'linki',
    categoryLabel: 'Linki',
    readingTime: '9 min czytania',
    datePublished: '2026-06-16',
  },
  'najlepsze-nike-linki-kakobuy': {
    slug: 'najlepsze-nike-linki-kakobuy',
    title: 'Najlepsze Nike Linki na Kakobuy - Top Produkty i Arkusze 2026',
    description: 'Zestawienie najlepszych linków do produktów Nike dostępnych na platformie Kakobuy. Sprawdzone linki do butów, ubrań i akcesoriów sportowych.',
    keywords: 'nike linki kakobuy, nike kakobuy spreadsheet, nike na kakobuy, kakobuy nike produkty, buty nike kakobuy',
    category: 'marki',
    categoryLabel: 'Marki',
    readingTime: '10 min czytania',
    datePublished: '2026-06-15',
  },
  'jak-kupowac-przez-agenta': {
    slug: 'jak-kupowac-przez-agenta',
    title: 'Jak Kupować przez Agenta - Instrukcja Krok po Kroku Kakobuy 2026',
    description: 'Kompletna instrukcja jak bezpiecznie i efektywnie dokonywać zakupów przez agenta na platformie Kakobuy. Od wyboru produktu przez płatność aż do dostawy do Polski.',
    keywords: 'jak kupować przez agenta, kakobuy instrukcja, agent zakupowy poradnik, kakobuy zakupy, kakobuy polska',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '15 min czytania',
    datePublished: '2026-06-14',
  },
  'kakobuy-polska': {
    slug: 'kakobuy-polska',
    title: 'Kakobuy Polska - Kompletny Przewodnik dla Polskich Użytkowników 2026',
    description: 'Wszystko co musisz wiedzieć o korzystaniu z Kakobuy w Polsce. Dostawa, cła, płatności i najlepsze praktyki dla polskich użytkowników platformy zakupowej.',
    keywords: 'kakobuy polska, kakobuy w polsce, kakobuy dostawa polska, kakobuy cło, kakobuy spreadsheet polska',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '14 min czytania',
    datePublished: '2026-06-13',
  },
  'kakobuy-opinie-polska': {
    slug: 'kakobuy-opinie-polska',
    title: 'Kakobuy Opinie 2026 - Co Mówią Prawdziwi Użytkownicy z Polski',
    description: 'Szczera analiza opinii o Kakobuy od polskich użytkowników. Plusy, minusy, ukryte koszty i na co uważać przed pierwszym zamówieniem na platformie.',
    keywords: 'kakobuy opinie, kakobuy opinie polska, kakobuy recenzje, kakobuy doświadczenia, czy warto kakobuy',
    category: 'opinie',
    categoryLabel: 'Opinie',
    readingTime: '12 min czytania',
    datePublished: '2026-06-12',
  },
  'kakobuy-vs-cnfans': {
    slug: 'kakobuy-vs-cnfans',
    title: 'Kakobuy vs CNFans - Który Agent Zakupowy Jest Lepszy w 2026?',
    description: 'Bezpośrednie porównanie Kakobuy i CNFans. Ceny, szybkość wysyłki, jakość obsługi i doświadczenia użytkowników obu platform zakupowych.',
    keywords: 'kakobuy vs cnfans, cnfans porównanie, kakobuy cnfans opinie, agent zakupowy porównanie, najlepszy agent 2026',
    category: 'porownania',
    categoryLabel: 'Porównania',
    readingTime: '13 min czytania',
    datePublished: '2026-06-11',
  },
  'kakobuy-vs-sugargoo': {
    slug: 'kakobuy-vs-sugargoo',
    title: 'Kakobuy vs Sugargoo - Porównanie Platform Zakupowych 2026',
    description: 'Szczegółowe porównanie Kakobuy z Sugargoo. Analiza kosztów wysyłki, czasu realizacji i dostępności produktów dla polskich klientów obu platform.',
    keywords: 'kakobuy vs sugargoo, sugargoo porównanie, kakobuy sugargoo opinie, platforma zakupowa porównanie, agent zakupowy',
    category: 'porownania',
    categoryLabel: 'Porównania',
    readingTime: '12 min czytania',
    datePublished: '2026-06-10',
  },
  'kakobuy-spreadsheet-2026': {
    slug: 'kakobuy-spreadsheet-2026',
    title: 'Kakobuy Spreadsheet 2026 - Najnowsze Arkusze i Linki do Produktów',
    description: 'Kompletny przegląd najnowszych arkuszy produktowych Kakobuy na rok 2026. Aktualizowane codziennie linki do najlepszych produktów w każdej kategorii.',
    keywords: 'kakobuy spreadsheet 2026, kakobuy arkusz 2026, kakobuy links 2026, spreadsheet produktowy, kakobuy nowości',
    category: 'arkusze',
    categoryLabel: 'Arkusze',
    readingTime: '10 min czytania',
    datePublished: '2026-06-09',
  },
  'poradnik-zakupowy-kakobuy': {
    slug: 'poradnik-zakupowy-kakobuy',
    title: 'Poradnik Zakupowy Kakobuy - Wszystko co Musisz Wiedzieć 2026',
    description: 'Kompleksowy poradnik zakupowy dla platformy Kakobuy. Od rejestracji przez pierwsze zamówienie aż po śledzenie przesyłki do Polski. Wszystkie niezbędne informacje.',
    keywords: 'poradnik zakupowy kakobuy, kakobuy poradnik, kakobuy jak kupować, kakobuy przewodnik, kakobuy zakupy',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '16 min czytania',
    datePublished: '2026-06-08',
  },
  'przewodnik-poczatkujacego-kakobuy': {
    slug: 'przewodnik-poczatkujacego-kakobuy',
    title: 'Przewodnik Początkującego - Pierwsze Kroki z Kakobuy w 2026',
    description: 'Przewodnik krok po kroku dla osób rozpoczynających przygodę z Kakobuy. Wszystko wyjaśnione prostym językiem od podstaw - idealny start dla nowych użytkowników.',
    keywords: 'przewodnik początkującego kakobuy, kakobuy pierwsze kroki, kakobuy dla początkujących, kakobuy poradnik start, kakobuy rejestracja',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '13 min czytania',
    datePublished: '2026-06-07',
  },
  'tanie-produkty-kakobuy': {
    slug: 'tanie-produkty-kakobuy',
    title: 'Tanie Produkty na Kakobuy - Jak Znaleźć Najlepsze Okazje w 2026',
    description: 'Praktyczny przewodnik jak znaleźć najlepsze okazje i najtańsze produkty na Kakobuy. Sekrety doświadczonych użytkowników platformy zakupowej.',
    keywords: 'tanie produkty kakobuy, kakobuy okazje, kakobuy promocje, kakobuy tanie zakupy, kakobuy spreadsheet',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '11 min czytania',
    datePublished: '2026-06-06',
  },
  'faq-kakobuy': {
    slug: 'faq-kakobuy',
    title: 'FAQ Kakobuy - Najczęściej Zadawane Pytania i Odpowiedzi 2026',
    description: 'Odpowiedzi na najczęściej zadawane pytania o platformie Kakobuy. Wszystko w jednym miejscu: od rejestracji przez zamówienia po zwroty i reklamacje.',
    keywords: 'faq kakobuy, kakobuy pytania, kakobuy odpowiedzi, kakobuy pomoc, kakobuy informacje',
    category: 'faq',
    categoryLabel: 'FAQ',
    readingTime: '8 min czytania',
    datePublished: '2026-06-05',
  },
  'jak-sprawdzic-qc': {
    slug: 'jak-sprawdzic-qc',
    title: 'Jak Sprawdzić QC na Kakobuy - Quality Check Guide 2026',
    description: 'Naucz się oceniać jakość produktów przed zakupem na Kakobuy. Kompletny przewodnik QC: na co zwracać uwagę, jak analizować zdjęcia i kiedy odrzucić produkt.',
    keywords: 'jak sprawdzić qc kakobuy, quality check kakobuy, kakobuy kontrola jakości, kakobuy qc guide, kakobuy zdjęcia qc',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '11 min czytania',
    datePublished: '2026-06-04',
  },
  'jak-zamowic-do-polski': {
    slug: 'jak-zamowic-do-polski',
    title: 'Jak Zamówić do Polski przez Kakobuy - Shipping Guide 2026',
    description: 'Kompletny przewodnik wysyłki: jak zamówić produkty z Kakobuy do Polski. Metody dostawy, koszty, cło, czas oczekiwania i śledzenie przesyłek.',
    keywords: 'jak zamówić do polski kakobuy, kakobuy wysyłka polska, kakobuy shipping, kakobuy dostawa, kakobuy cło polska',
    category: 'poradniki',
    categoryLabel: 'Poradniki',
    readingTime: '14 min czytania',
    datePublished: '2026-06-03',
  },
  'jak-uniknac-oszustw': {
    slug: 'jak-uniknac-oszustw',
    title: 'Jak Uniknąć Oszustw na Kakobuy - Poradnik Bezpieczeństwa 2026',
    description: 'Praktyczne wskazówki jak chronić się przed oszustami na platformie Kakobuy. Rozpoznawanie podejrzanych sprzedawców, bezpieczne płatności i ochrona danych.',
    keywords: 'jak uniknąć oszustw kakobuy, kakobuy bezpieczeństwo, kakobuy scam, kakobuy oszuści, bezpieczne zakupy kakobuy',
    category: 'bezpieczenstwo',
    categoryLabel: 'Bezpieczeństwo',
    readingTime: '12 min czytania',
    datePublished: '2026-06-02',
  },
  'bezpieczne-platnosci-kakobuy': {
    slug: 'bezpieczne-platnosci-kakobuy',
    title: 'Bezpieczne Płatności na Kakobuy - Kompletny Przewodnik 2026',
    description: 'Jak bezpiecznie dokonywać płatności na platformie Kakobuy. Dostępne metody płatności, ochrona kupującego i jak uniknąć problemów z transakcjami.',
    keywords: 'bezpieczne płatności kakobuy, kakobuy płatności, kakobuy payment, kakobuy transakcje, kakobuy bezpieczeństwo płatności',
    category: 'bezpieczenstwo',
    categoryLabel: 'Bezpieczeństwo',
    readingTime: '10 min czytania',
    datePublished: '2026-06-01',
  },
};

export const brands: BrandItem[] = [
  {
    name: 'Nike Spreadsheet',
    slug: 'nike-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-nike-01',
    imageQuery: 'Minimalist%20Nike%20sneakers%20product%20photography%20on%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20composition%2C%20warm%20neutral%20aesthetic%20with%20organic%20details',
  },
  {
    name: 'Adidas Spreadsheet',
    slug: 'adidas-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-adidas-02',
    imageQuery: 'Minimalist%20Adidas%20trainers%20product%20photography%20on%20cream%20background%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20style%2C%20warm%20neutral%20tones%20with%20organic%20composition',
  },
  {
    name: 'Essentials Spreadsheet',
    slug: 'essentials-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-essentials-03',
    imageQuery: 'Minimal%20Essentials%20hoodie%20product%20photography%20on%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20warm%20neutral%20aesthetic%20composition',
  },
  {
    name: 'Trapstar Spreadsheet',
    slug: 'trapstar-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-trapstar-04',
    imageQuery: 'Minimalist%20streetwear%20jacket%20product%20photography%20on%20cream%20background%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20style%2C%20warm%20neutral%20tones%20with%20organic%20details',
  },
  {
    name: 'Yeezy Spreadsheet',
    slug: 'yeezy-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-yeezy-05',
    imageQuery: 'Minimal%20Yeezy%20sneakers%20product%20photography%20on%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20composition%2C%20warm%20neutral%20aesthetic%20with%20organic%20texture',
  },
  {
    name: 'Jordan Spreadsheet',
    slug: 'jordan-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-jordan-06',
    imageQuery: 'Minimalist%20Jordan%20sneakers%20product%20photography%20on%20cream%20surface%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20style%2C%20warm%20neutral%20aesthetic%20with%20organic%20composition',
  },
  {
    name: 'Stussy Spreadsheet',
    slug: 'stussy-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-stussy-07',
    imageQuery: 'Minimal%20Stussy%20t-shirt%20product%20photography%20on%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20warm%20neutral%20tones%20with%20organic%20details',
  },
  {
    name: 'Supreme Spreadsheet',
    slug: 'supreme-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-supreme-08',
    imageQuery: 'Minimalist%20Supreme%20accessory%20product%20photography%20on%20cream%20background%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20composition%2C%20warm%20neutral%20aesthetic%20with%20organic%20details',
  },
  {
    name: 'New Balance Spreadsheet',
    slug: 'new-balance-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-nb-09',
    imageQuery: 'Minimal%20New%20Balance%20sneakers%20product%20photography%20on%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20warm%20neutral%20tones%20with%20organic%20composition',
  },
  {
    name: 'Stone Island Spreadsheet',
    slug: 'stone-island-spreadsheet',
    icon: 'ri-checkbox-blank-circle-fill',
    seq: 'brand-si-10',
    imageQuery: 'Minimalist%20Stone%20Island%20jacket%20product%20photography%20on%20cream%20surface%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20style%2C%20warm%20neutral%20aesthetic%20with%20organic%20texture',
  },
];

export const latestArticles: ArticleItem[] = [
  {
    title: 'Czym jest Kakobuy Spreadsheet - Kompletny Przewodnik',
    slug: 'czym-jest-kakobuy-spreadsheet',
    excerpt: 'Dowiedz się czym dokładnie jest Kakobuy Spreadsheet, jak działa i dlaczego jest niezbędnym narzędziem dla każdego użytkownika platformy Kakobuy.',
    category: 'Poradniki',
    seq: 'article-guide-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20workspace%20with%20macbook%20showing%20colorful%20spreadsheet%20on%20warm%20oak%20desk%2C%20ceramic%20coffee%20cup%20beside%2C%20soft%20morning%20light%20through%20sheer%20curtain%2C%20editorial%20photography%2C%20productive%20aesthetic&width=600&height=400&seq=art-latest-01-v2&orientation=landscape',
  },
  {
    title: 'Jak działa Kakobuy - Poradnik dla początkujących',
    slug: 'jak-dziala-kakobuy',
    excerpt: 'Poznaj podstawy działania platformy Kakobuy. Przewodnik krok po kroku dla osób rozpoczynających przygodę z zakupami przez agenta.',
    category: 'Poradniki',
    seq: 'article-guide-02',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20shopping%20app%20interface%20beside%20minimal%20notebook%20on%20warm%20terracotta%20desk%20surface%2C%20soft%20overhead%20natural%20light%2C%20clean%20editorial%20composition%2C%20modern%20tech%20lifestyle&width=600&height=400&seq=art-latest-02-v2&orientation=landscape',
  },
  {
    title: 'Kakobuy vs Pandabuy - Porównanie agentów 2026',
    slug: 'kakobuy-vs-pandabuy',
    excerpt: 'Szczegółowe porównanie dwóch najpopularniejszych agentów zakupowych. Który jest lepszy dla polskich użytkowników w 2026 roku?',
    category: 'Porównania',
    seq: 'article-compare-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20elegant%20product%20boxes%20side%20by%20side%20on%20warm%20cream%20surface%2C%20soft%20studio%20lighting%20creating%20symmetric%20shadows%2C%20minimal%20comparison%20concept%20photography%2C%20clean%20editorial%20style&width=600&height=400&seq=art-latest-03-v2&orientation=landscape',
  },
  {
    title: 'Czy Kakobuy jest bezpieczny - Kompletny poradnik bezpieczeństwa',
    slug: 'czy-kakobuy-jest-bezpieczny',
    excerpt: 'Wszystko co musisz wiedzieć o bezpieczeństwie na platformie Kakobuy. Jak chronić swoje dane i unikać oszustw podczas zakupów.',
    category: 'Bezpieczeństwo',
    seq: 'article-safety-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimal%20security%20concept%20with%20transparent%20glass%20shield%20symbol%20on%20warm%20beige%20textured%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography%2C%20trust%20and%20protection%20aesthetic&width=600&height=400&seq=art-latest-04-v2&orientation=landscape',
  },
  {
    title: 'Jak znaleźć najlepszych sprzedawców na Kakobuy',
    slug: 'najlepsi-sprzedawcy-kakobuy',
    excerpt: 'Praktyczne wskazówki jak znaleźć sprawdzonych i godnych zaufania sprzedawców na platformie Kakobuy. Kryteria oceny i lista polecanych.',
    category: 'Poradniki',
    seq: 'article-sellers-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20clothing%20items%20neatly%20arranged%20on%20warm%20oak%20table%20with%20magnifying%20glass%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography%2C%20careful%20selection%20concept&width=600&height=400&seq=art-latest-05-v2&orientation=landscape',
  },
  {
    title: 'Kakobuy links 2026 - Aktualna lista linków',
    slug: 'kakobuy-links-2026',
    excerpt: 'Zaktualizowana lista wszystkich działających linków do arkuszy produktowych Kakobuy na rok 2026. Regularnie sprawdzane i weryfikowane.',
    category: 'Linki',
    seq: 'article-links-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Interconnected%20minimal%20nodes%20and%20lines%20pattern%20on%20warm%20cream%20background%2C%20soft%20diffused%20lighting%2C%20clean%20digital%20concept%20photography%2C%20network%20aesthetic%20with%20organic%20texture&width=600&height=400&seq=art-latest-06-v2&orientation=landscape',
  },
  {
    title: 'Najlepsze Nike linki na Kakobuy - Top produkty',
    slug: 'najlepsze-nike-linki-kakobuy',
    excerpt: 'Zestawienie najlepszych linków do produktów Nike dostępnych na platformie Kakobuy. Sprawdzone linki do butów, ubrań i akcesoriów.',
    category: 'Marki',
    seq: 'article-nike-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nike%20product%20collection%20flat%20lay%20with%20sneakers%20and%20sportswear%20on%20warm%20grey%20concrete%2C%20soft%20natural%20lighting%2C%20editorial%20brand%20photography%2C%20clean%20athletic%20aesthetic&width=600&height=400&seq=art-latest-07-v2&orientation=landscape',
  },
  {
    title: 'Jak kupować przez agenta - Instrukcja krok po kroku',
    slug: 'jak-kupowac-przez-agenta',
    excerpt: 'Kompletna instrukcja jak bezpiecznie i efektywnie dokonywać zakupów przez agenta na platformie Kakobuy. Od wyboru produktu do dostawy.',
    category: 'Poradniki',
    seq: 'article-agent-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20guide%20concept%20with%20numbered%20cards%20on%20warm%20beige%20surface%2C%20soft%20studio%20lighting%2C%20minimal%20editorial%20photography%2C%20organized%20instructional%20aesthetic&width=600&height=400&seq=art-latest-08-v2&orientation=landscape',
  },
];

// 9 new SEO articles for homepage
export const seoArticles: ArticleItem[] = [
  {
    title: 'Kakobuy Polska - Kompletny przewodnik dla polskich użytkowników',
    slug: 'kakobuy-polska',
    excerpt: 'Wszystko co musisz wiedzieć o korzystaniu z Kakobuy w Polsce. Dostawa, cła, płatności i najlepsze praktyki dla polskich użytkowników.',
    category: 'Poradniki',
    seq: 'seo-pol-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Polish%20flag%20colors%20subtly%20integrated%20with%20minimal%20shopping%20concept%20on%20warm%20cream%20surface%2C%20package%20with%20shipping%20label%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography&width=600&height=400&seq=seo-poland-v2&orientation=landscape',
  },
  {
    title: 'Kakobuy opinie 2026 - Co mówią prawdziwi użytkownicy',
    slug: 'kakobuy-opinie-polska',
    excerpt: 'Szczera analiza opinii o Kakobuy od polskich użytkowników. Plusy, minusy, ukryte koszty i na co uważać przed pierwszym zamówieniem.',
    category: 'Opinie',
    seq: 'seo-opin-02',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Five%20star%20review%20concept%20with%20minimal%20product%20on%20warm%20beige%20textured%20surface%2C%20soft%20golden%20lighting%2C%20clean%20editorial%20photography%2C%20satisfaction%20rating%20aesthetic&width=600&height=400&seq=seo-opinie-v2&orientation=landscape',
  },
  {
    title: 'Kakobuy vs CNFans - Który agent jest lepszy?',
    slug: 'kakobuy-vs-cnfans',
    excerpt: 'Bezpośrednie porównanie Kakobuy i CNFans. Ceny, szybkość wysyłki, jakość obsługi i doświadczenia użytkowników obu platform.',
    category: 'Porównania',
    seq: 'seo-cnf-03',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20contrasting%20minimal%20product%20packages%20on%20warm%20oatmeal%20surface%2C%20soft%20side%20lighting%20creating%20dual%20shadows%2C%20comparison%20concept%20editorial%20photography%2C%20clean%20balanced%20composition&width=600&height=400&seq=seo-cnfans-v2&orientation=landscape',
  },
  {
    title: 'Kakobuy vs Sugargoo - Porównanie platform zakupowych',
    slug: 'kakobuy-vs-sugargoo',
    excerpt: 'Szczegółowe porównanie Kakobuy z Sugargoo. Analiza kosztów wysyłki, czasu realizacji i dostępności produktów dla polskich klientów.',
    category: 'Porównania',
    seq: 'seo-sug-04',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20concept%20with%20two%20minimal%20shopping%20interfaces%20on%20warm%20beige%20backdrop%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20photography%2C%20versus%20aesthetic&width=600&height=400&seq=seo-sugargoo-v2&orientation=landscape',
  },
  {
    title: 'Kakobuy Spreadsheet 2026 - Najnowsze arkusze i linki',
    slug: 'kakobuy-spreadsheet-2026',
    excerpt: 'Kompletny przegląd najnowszych arkuszy produktowych Kakobuy na rok 2026. Aktualizowane codziennie linki do najlepszych produktów.',
    category: 'Arkusze',
    seq: 'seo-spr-05',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20with%20detailed%20spreadsheet%20data%20on%20screen%20beside%20elegant%20product%20samples%20on%20warm%20oak%20desk%2C%20soft%20morning%20light%2C%20editorial%20photography%2C%20organized%20professional%20aesthetic&width=600&height=400&seq=seo-spread-v2&orientation=landscape',
  },
  {
    title: 'Poradnik zakupowy Kakobuy - Wszystko co musisz wiedzieć',
    slug: 'poradnik-zakupowy-kakobuy',
    excerpt: 'Kompleksowy poradnik zakupowy dla platformy Kakobuy. Od rejestracji przez pierwsze zamówienie aż po śledzenie przesyłki do Polski.',
    category: 'Poradniki',
    seq: 'seo-por-06',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20shopping%20guide%20concept%20with%20neatly%20arranged%20fashion%20items%20and%20checklist%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20organized%20lifestyle%20aesthetic&width=600&height=400&seq=seo-guide-v2&orientation=landscape',
  },
  {
    title: 'Przewodnik początkującego - Pierwsze kroki z Kakobuy',
    slug: 'przewodnik-poczatkujacego-kakobuy',
    excerpt: 'Przewodnik krok po kroku dla osób rozpoczynających przygodę z Kakobuy. Wszystko wyjaśnione prostym językiem od podstaw.',
    category: 'Poradniki',
    seq: 'seo-pocz-07',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Friendly%20beginner%20concept%20with%20open%20notebook%20and%20pen%20beside%20smartphone%20on%20warm%20terracotta%20surface%2C%20soft%20morning%20light%2C%20editorial%20photography%2C%20learning%20aesthetic&width=600&height=400&seq=seo-beginner-v2&orientation=landscape',
  },
  {
    title: 'Tanie produkty na Kakobuy - Jak znaleźć najlepsze okazje',
    slug: 'tanie-produkty-kakobuy',
    excerpt: 'Praktyczny przewodnik jak znaleźć najlepsze okazje i najtańsze produkty na Kakobuy. Sekrety doświadczonych użytkowników platformy.',
    category: 'Poradniki',
    seq: 'seo-tanie-08',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimal%20product%20with%20discount%20tag%20concept%20on%20warm%20beige%20surface%2C%20soft%20golden%20hour%20lighting%2C%20clean%20editorial%20photography%2C%20bargain%20hunting%20aesthetic&width=600&height=400&seq=seo-deals-v2&orientation=landscape',
  },
  {
    title: 'FAQ Kakobuy - Najczęściej zadawane pytania i odpowiedzi',
    slug: 'faq-kakobuy',
    excerpt: 'Odpowiedzi na najczęściej zadawane pytania o platformie Kakobuy. Wszystko w jednym miejscu: od rejestracji po zwroty i reklamacje.',
    category: 'FAQ',
    seq: 'seo-faq-09',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Question%20mark%20concept%20with%20minimal%20arranged%20product%20on%20warm%20cream%20surface%2C%20soft%20diffused%20lighting%2C%20clean%20editorial%20photography%2C%20helpful%20information%20aesthetic&width=600&height=400&seq=seo-faq-v2&orientation=landscape',
  },
];

export const popularArticles: ArticleItem[] = [
  {
    title: 'Czym jest Kakobuy Spreadsheet - Kompletny Przewodnik',
    slug: 'czym-jest-kakobuy-spreadsheet',
    excerpt: 'Dowiedz się czym dokładnie jest Kakobuy Spreadsheet, jak działa i dlaczego jest niezbędnym narzędziem.',
    category: 'Poradniki',
    seq: 'pop-article-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Neat%20workspace%20with%20laptop%20showing%20spreadsheet%20data%20on%20warm%20oak%20desk%2C%20soft%20natural%20window%20light%2C%20editorial%20productivity%20photography%2C%20clean%20organized%20aesthetic&width=600&height=400&seq=art-pop-01-v2&orientation=landscape',
  },
  {
    title: 'Czy Kakobuy jest bezpieczny - Poradnik bezpieczeństwa',
    slug: 'czy-kakobuy-jest-bezpieczny',
    excerpt: 'Wszystko co musisz wiedzieć o bezpieczeństwie na platformie Kakobuy.',
    category: 'Bezpieczeństwo',
    seq: 'pop-article-02',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Safety%20concept%20with%20minimal%20padlock%20symbol%20on%20warm%20cream%20textured%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography%2C%20protection%20aesthetic&width=600&height=400&seq=art-pop-02-v2&orientation=landscape',
  },
  {
    title: 'Kakobuy vs Pandabuy - Porównanie agentów 2026',
    slug: 'kakobuy-vs-pandabuy',
    excerpt: 'Szczegółowe porównanie dwóch najpopularniejszych agentów zakupowych.',
    category: 'Porównania',
    seq: 'pop-article-03',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20minimal%20packages%20facing%20each%20other%20on%20warm%20oatmeal%20surface%2C%20soft%20studio%20lighting%2C%20comparison%20editorial%20photography&width=600&height=400&seq=art-pop-03-v2&orientation=landscape',
  },
  {
    title: 'Jak działa Kakobuy - Poradnik dla początkujących',
    slug: 'jak-dziala-kakobuy',
    excerpt: 'Poznaj podstawy działania platformy Kakobuy.',
    category: 'Poradniki',
    seq: 'pop-article-04',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20and%20notebook%20on%20warm%20terracotta%20desk%2C%20soft%20morning%20light%2C%20editorial%20tech%20lifestyle%20photography%2C%20clean%20modern%20aesthetic&width=600&height=400&seq=art-pop-04-v2&orientation=landscape',
  },
  {
    title: 'Jak kupować przez agenta - Instrukcja krok po kroku',
    slug: 'jak-kupowac-przez-agenta',
    excerpt: 'Kompletna instrukcja jak bezpiecznie dokonywać zakupów przez agenta.',
    category: 'Poradniki',
    seq: 'pop-article-05',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20instruction%20cards%20with%20minimal%20product%20on%20warm%20beige%20surface%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20photography&width=600&height=400&seq=art-pop-05-v2&orientation=landscape',
  },
  {
    title: 'Kakobuy links 2026 - Aktualna lista linków',
    slug: 'kakobuy-links-2026',
    excerpt: 'Zaktualizowana lista wszystkich działających linków do arkuszy produktowych.',
    category: 'Linki',
    seq: 'pop-article-06',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20network%20links%20concept%20on%20warm%20cream%20backdrop%2C%20soft%20diffused%20lighting%2C%20clean%20editorial%20photography%2C%20connected%20nodes%20aesthetic&width=600&height=400&seq=art-pop-06-v2&orientation=landscape',
  },
  {
    title: 'Najlepsze Nike linki na Kakobuy - Top produkty',
    slug: 'najlepsze-nike-linki-kakobuy',
    excerpt: 'Zestawienie najlepszych linków do produktów Nike na Kakobuy.',
    category: 'Marki',
    seq: 'pop-article-07',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nike%20sneakers%20and%20accessories%20flat%20lay%20on%20warm%20grey%20concrete%2C%20soft%20natural%20lighting%2C%20editorial%20brand%20photography&width=600&height=400&seq=art-pop-07-v2&orientation=landscape',
  },
];

export const guides: ArticleItem[] = [
  {
    title: 'Jak kupować przez agenta',
    slug: 'jak-kupowac-przez-agenta',
    excerpt: 'Instrukcja krok po kroku dla początkujących.',
    category: 'Poradniki',
    seq: 'guide-agent-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimal%20shopping%20guide%20with%20numbered%20steps%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography&width=600&height=400&seq=art-guide-01-v2&orientation=landscape',
  },
  {
    title: 'Jak korzystać ze Spreadsheet',
    slug: 'czym-jest-kakobuy-spreadsheet',
    excerpt: 'Naucz się efektywnie używać arkuszy produktowych.',
    category: 'Poradniki',
    seq: 'guide-spreadsheet-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Laptop%20displaying%20spreadsheet%20on%20warm%20oak%20desk%20with%20coffee%2C%20soft%20morning%20light%2C%20editorial%20productivity%20photography&width=600&height=400&seq=art-guide-02-v2&orientation=landscape',
  },
  {
    title: 'Jak znaleźć sprzedawcę',
    slug: 'najlepsi-sprzedawcy-kakobuy',
    excerpt: 'Kryteria wyboru zaufanych sprzedawców.',
    category: 'Poradniki',
    seq: 'guide-seller-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20minimal%20product%20on%20warm%20beige%20surface%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20photography&width=600&height=400&seq=art-guide-03-v2&orientation=landscape',
  },
  {
    title: 'QC Guide - Jak sprawdzić jakość',
    slug: 'jak-sprawdzic-qc',
    excerpt: 'Naucz się oceniać jakość produktów przed zakupem.',
    category: 'Poradniki',
    seq: 'guide-qc-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Product%20inspection%20concept%20with%20checklist%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography&width=600&height=400&seq=art-guide-04-v2&orientation=landscape',
  },
  {
    title: 'Shipping Guide - Wysyłka do Polski',
    slug: 'jak-zamowic-do-polski',
    excerpt: 'Wszystko o wysyłce i dostawie do Polski.',
    category: 'Poradniki',
    seq: 'guide-shipping-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20with%20label%20on%20warm%20oatmeal%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20delivery%20concept&width=600&height=400&seq=art-guide-05-v2&orientation=landscape',
  },
];

export const safetyArticles: ArticleItem[] = [
  {
    title: 'Czy Kakobuy jest bezpieczny',
    slug: 'czy-kakobuy-jest-bezpieczny',
    excerpt: 'Kompleksowa analiza bezpieczeństwa platformy.',
    category: 'Bezpieczeństwo',
    seq: 'safety-secure-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shield%20symbol%20with%20minimal%20product%20on%20warm%20beige%20surface%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20photography&width=600&height=400&seq=art-safe-01-v2&orientation=landscape',
  },
  {
    title: 'Jak uniknąć oszustw',
    slug: 'jak-uniknac-oszustw',
    excerpt: 'Praktyczne wskazówki jak chronić się przed oszustami.',
    category: 'Bezpieczeństwo',
    seq: 'safety-scam-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warning%20concept%20with%20minimal%20product%20and%20alert%20icon%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography&width=600&height=400&seq=art-safe-02-v2&orientation=landscape',
  },
  {
    title: 'Bezpieczne płatności',
    slug: 'bezpieczne-platnosci-kakobuy',
    excerpt: 'Jak bezpiecznie dokonywać płatności na platformie.',
    category: 'Bezpieczeństwo',
    seq: 'safety-payment-01',
    imageQuery: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Credit%20card%20concept%20with%20minimal%20product%20on%20warm%20beige%20surface%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20photography&width=600&height=400&seq=art-safe-03-v2&orientation=landscape',
  },
];